import { render } from "./t_report_tickets.vue?vue&type=template&id=f89fed7e&scoped=true"
import script from "./t_report_tickets.vue?vue&type=script&lang=js"
export * from "./t_report_tickets.vue?vue&type=script&lang=js"

import "./t_report_tickets.vue?vue&type=style&index=0&id=f89fed7e&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\ssd_ice\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f89fed7e"]])

export default __exports__